'use strict';

export const styleClassConstants = {
  editSubmission: {
    status: {
      isEdited: 'icon-status-completed',
      isPreviouslySubmitted: 'icon-status-previously-completed',
      isUnchanged: 'icon-status-incomplete-dark'
    }
  }
};
